/**
 * @file
 *
 * Customization script for the 'pam/strikebenefit' form.
 */

import $ from 'jquery'
import get from 'lodash/get'
import isArray from 'lodash/isArray'
import moment from 'moment/min/moment-with-locales'

$(document).ready(() => {
  console.log('strikebenefit.js: document is ready')
  const $strike = $('[name=lakko_tunnus]')
  const $strikeDays = $('.lakkopaivat')
  const $strikeName = $('#lakko_nimi')
  const $locale = $('[name=locale]')
  const $empty = $('.empty')
  const $strikeForm = $('.strike_form')
  const $submit = $('.submitbutton')
  const $bicCode = $('[name=pankin_bic_koodi]')
  const lakkoTunnus = require('../../../resources/pam/strike')
  let locale

  function emptyStrike () {
    if (lakkoTunnus.length > 1) {
      $empty.addClass('hidden')
      $strikeForm.removeClass('hidden')
      $submit.removeClass('hidden')
    } else {
      $empty.removeClass('hidden')
      $strikeForm.addClass('hidden')
      $submit.addClass('hidden')
    }
  }

  function strikeDates () {
    // Additional information about the strike can be added after the strike date on the form. The Finnish text is the default.
    let strikeMoreInformation = $strike.children('option:selected').data('strikemoreinformation_fi') || ''

    if (locale === 'fi') {
      moment.locale('fi')
    } else if (locale === 'sv') {
      moment.locale('sv')
      if ($strike.children('option:selected').data('strikemoreinformation_sv')) {
        strikeMoreInformation = $strike.children('option:selected').data('strikemoreinformation_sv')
      }
    } else if (locale === 'en') {
      moment.locale('en')
      if ($strike.children('option:selected').data('strikemoreinformation_en')) {
        strikeMoreInformation = $strike.children('option:selected').data('strikemoreinformation_en')
      }
    }

    $strikeDays.empty()

    const selectedStrikeStartdate = $strike.children('option:selected').data('startdate')

    if (selectedStrikeStartdate !== undefined) {
      let start = moment(selectedStrikeStartdate)
      let end = moment($strike.children('option:selected').data('enddate'))
      const label = $strike.children('option:selected').data('translate')
      const automaticApproval = $strike.children('option:selected').data('automaticapproval')
      let isChecked = ''
      let checkboxHtml = ''

      // The function automatic approval of strike allowances (lakkohakemuksen automaattihyväksyntä) is on in Lyyti
      if (automaticApproval === 'K') { // Set in clas strike.js
        // Only the last date (endDate) has to be sent from the form.
        const rawDateK = end.format('YYYY-MM-DDT00:00:00')
        const lakkopaivaK = get(window.queryparameters, 'lakkopaiva')
        isChecked = ''
        if (lakkopaivaK) {
          if (isArray(lakkopaivaK) && lakkopaivaK.includes(rawDateK)) {
            isChecked = 'checked'
          }
          if (lakkopaivaK === rawDateK) {
            isChecked = 'checked'
          }
        }
        // Show only one strike period to choose from.
        checkboxHtml = '<div>' +
          '<label>' +
            '<input type="checkbox" name="lakkopaiva" ' + isChecked + ' value="' + rawDateK + '">' +
            '<span class="dates">' + label + ' ' + strikeMoreInformation + ' </span> ' +
          '</label>' +
        '</div>'
        $strikeDays.append(checkboxHtml)
        // The function automatic approval of strike allowances is off in Lyyti
      } else if (automaticApproval === 'E') { // Set in clas strike.js
        // Choose several strike days. The value of each selected number of days is transmitted from the form.
        while (start.isSameOrBefore(end)) {
          const formattedDate = ' ' + start.format('DD.MM.YYYY')
          const rawDateE = start.format('YYYY-MM-DDT00:00:00')
          const lakkopaivaE = get(window.queryparameters, 'lakkopaiva')
          isChecked = ''
          if (lakkopaivaE) {
            if (isArray(lakkopaivaE) && lakkopaivaE.includes(rawDateE)) {
              isChecked = 'checked'
            }
            if (lakkopaivaE === rawDateE) {
              isChecked = 'checked'
            }
          }
          // Show all the dates between start and end date to choose from.
          checkboxHtml = '<div>' +
            '<label>' +
              '<input type="checkbox" name="lakkopaiva" ' + isChecked + ' value="' + rawDateE + '">' +
              '<span class="dates">' + formattedDate + '</span> ' + ' ' + strikeMoreInformation +
            '</label>' +
          '</div>'
          $strikeDays.append(checkboxHtml)
          start = start.add(1, 'days')
        }
      }
    }
  }

  function getStrikeName () {
    var strikeName = $strike.children('option:selected').data('translate')
    $strikeName.val(strikeName)
  }

  $locale.change((event) => {
    locale = $locale.val()
    if ($strike.val()) {
      strikeDates()
    }
  })
  $strike.change((event) => {
    locale = $locale.val()
    if ($strike.val()) {
      strikeDates()
      getStrikeName()
    }
  })

  // Preventing whitespaces in field bic-koodi
  $bicCode.on('input', () => {
    let bicCodeValue = $bicCode.length ? $bicCode.val() : ''
    bicCodeValue = bicCodeValue.replace(/\s+/g, '')
    $bicCode.val(bicCodeValue)
  })
  strikeDates()
  emptyStrike()
})
